import type { RoomUser as RoomUser_ } from 'quickvo-sdk-js';
import type { useQuickVO } from '.';

export type UseQuickVOResult = ReturnType<typeof useQuickVO>;

export type RoomUser = RoomUser_;

export const enum MediaType {
  MICROPHONECAMERA_AUDIO = 'microphoneCamera_audio',
  MICROPHONECAMERA_VIDEO = 'microphoneCamera_video',
  SCREENSHARING_VIDEO = 'screenSharing_video',
  SCREENSHARING_AUDIO = 'screenSharing_audio',
}

export const enum MediaDeviceKind {
  AUDIO_INPUT = 'audioinput',
  AUDIO_OUTPUT = 'audiooutput',
  VIDEO_INPUT = 'videoinput',
}

export type RoomUsersStreams = {
  updateStreams: RoomUser['updateStreams'];
  userId: string;
};

export interface MediaDevicesType {
  devicesVideoInput: MediaDeviceInfo[];
  devicesAudioInput: MediaDeviceInfo[];
  devicesAudioOutput: MediaDeviceInfo[];
}
